'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUCCESS = exports.SUCCESS = 'SUCCESS';
var FAILURE = exports.FAILURE = 'FAILURE';
var PENDING = exports.PENDING = 'PENDING';
var TIMEOUT = exports.TIMEOUT = 'TIMEOUT';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/internal/ResultStatus.js
// module id = 633
// module chunks = 3 4